import { useQuery } from 'react-query';
import { getCollectionsForPlace } from '../api';
import { CollectionContentShape, CollectionShape } from '../types';

const FIVE_MINUTES = 5 * 60 * 1000;

const transformEditorialCollection = (
    collection: CollectionShape,
): CollectionContentShape => ({
    displayCreatorName: collection.display_creator_name,
    eventCount: collection.event_count,
    id: collection.id,
    imageLarge: {
        url: collection?.image_large?.url,
    },
    name: collection.name,
    summary: collection.summary,
});

export const useFeaturedCollectionsForPlace = (
    place: string | string[],
    initialData?: CollectionContentShape[],
) => {
    const response = useQuery<CollectionContentShape[], Error>(
        ['featured-collections', { place }],
        async () => {
            const collectionResponse = await getCollectionsForPlace(place);

            const formattedCollectionResponse = collectionResponse.collections.map(
                transformEditorialCollection,
            );

            return formattedCollectionResponse;
        },
        {
            initialData,
            enabled: !!place,
            retry: false,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            refetchOnMount: false,
            staleTime: FIVE_MINUTES,
        },
    );
    return response;
};
